import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { EnterpriseFeatureConfigService, EnterpriseFeatureKey } from 'app/services/enterprise-feature-config.service';
import { SecurityProfileService } from 'app/services/securityProfile.service';
import { map } from 'rxjs';
import { ROLES } from 'shared-models';

const resolveFallbackUrl = (role: ROLES | null): string => {
  if (role === ROLES.ADMIN || role === ROLES.GESTOR || role === ROLES.SUPERADMIN) {
    return '/admin/panel';
  }

  return '/landing/home';
};

export const ModuleFeatureGuard: CanActivateFn | CanActivateChildFn = (route) => {
  const router = inject(Router);
  const featureConfigService = inject(EnterpriseFeatureConfigService);
  const securityProfileService = inject(SecurityProfileService);
  const moduleFeature = route.data?.['moduleFeature'] as EnterpriseFeatureKey | undefined;

  if (!moduleFeature) {
    return true;
  }

  return featureConfigService.ensureLoaded().pipe(
    map(() => {
      if (featureConfigService.isFeatureEnabled(moduleFeature)) {
        return true;
      }

      return router.parseUrl(resolveFallbackUrl(securityProfileService.getRole()));
    })
  );
};
